function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__c",
  x1: 78.42,
  y1: 74.74,
  x2: 22.1,
  y2: 31.17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__a",
  x1: 56.97,
  y1: 83.07,
  x2: 1.65,
  y2: -3.06,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__d",
  x1: 62.34,
  y1: 77.42,
  x2: 7.02,
  y2: -8.72,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__e",
  x1: 67.71,
  y1: 71.76,
  x2: 12.38,
  y2: -14.37,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__f",
  x1: 73.07,
  y1: 66.11,
  x2: 17.75,
  y2: -20.02,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__g",
  x1: 78.44,
  y1: 60.45,
  x2: 23.12,
  y2: -25.68,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__b",
  x1: -17.96,
  y1: 19,
  x2: 72.7,
  y2: 19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#80e8bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d2f7e7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__h",
  x1: 56.97,
  y1: 99.07,
  x2: 1.65,
  y2: 12.94,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__i",
  x1: 62.34,
  y1: 93.42,
  x2: 7.02,
  y2: 7.28,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__j",
  x1: 67.71,
  y1: 87.76,
  x2: 12.38,
  y2: 1.63,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__k",
  x1: 73.07,
  y1: 82.11,
  x2: 17.75,
  y2: -4.02,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__l",
  x1: 78.44,
  y1: 76.45,
  x2: 23.12,
  y2: -9.68,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__m",
  x1: -17.96,
  y1: 35,
  x2: 72.7,
  y2: 35,
  xlinkHref: "#1-company_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__n",
  x1: 56.97,
  y1: 115.07,
  x2: 1.65,
  y2: 28.94,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__o",
  x1: 62.34,
  y1: 109.42,
  x2: 7.02,
  y2: 23.28,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__p",
  x1: 67.71,
  y1: 103.76,
  x2: 12.38,
  y2: 17.63,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__q",
  x1: 73.07,
  y1: 98.11,
  x2: 17.75,
  y2: 11.98,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__r",
  x1: 78.44,
  y1: 92.45,
  x2: 23.12,
  y2: 6.32,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__s",
  x1: -17.96,
  y1: 51,
  x2: 72.7,
  y2: 51,
  xlinkHref: "#1-company_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__t",
  x1: 63.54,
  y1: 56.31,
  x2: 63.54,
  y2: 70.92,
  xlinkHref: "#1-company_svg__b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__u",
  x1: 71.62,
  y1: 81.2,
  x2: 59.7,
  y2: 35.92,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__v",
  x1: 23.74,
  y1: 84.27,
  x2: 22.14,
  y2: 58.72,
  xlinkHref: "#1-company_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1-company_svg__w",
  x1: 37.67,
  y1: 83.27,
  x2: 36.08,
  y2: 57.72,
  xlinkHref: "#1-company_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 0h54a2 2 0 012 2v70H0V2a2 2 0 012-2z",
  fill: "url(#1-company_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__a)",
  d: "M8.5 8h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__d)",
  d: "M17.5 8h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__e)",
  d: "M26.5 8h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__f)",
  d: "M35.5 8h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__g)",
  d: "M44.5 8h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__b)",
  d: "M0 18h58v2H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__h)",
  d: "M8.5 24h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__i)",
  d: "M17.5 24h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__j)",
  d: "M26.5 24h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__k)",
  d: "M35.5 24h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__l)",
  d: "M44.5 24h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__m)",
  d: "M0 34h58v2H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__n)",
  d: "M8.5 40h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__o)",
  d: "M17.5 40h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__p)",
  d: "M26.5 40h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__q)",
  d: "M35.5 40h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__r)",
  d: "M44.5 40h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__s)",
  d: "M0 50h58v2H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__t)",
  d: "M61.54 51h4v21h-4z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63.54,
  cy: 50.5,
  r: 11,
  fill: "url(#1-company_svg__u)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__v)",
  d: "M16.5 57h12v15h-12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#1-company_svg__w)",
  d: "M30.5 57h12v15h-12z"
}));

function Svg1Company(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.54 72"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { Svg1Company as ReactComponent };